module.exports = __webpack_public_path__ + "img/workNewsCover2.0f8e02bd.png";